module.exports = __webpack_public_path__ + "img/logopplotto.d39d6693.png";